import { debounce } from 'lodash';
import Cart from '../../../resources/scripts/views/cart';

class BrixProductHeader {
  static init(...parameters) {
    return new BrixProductHeader(...parameters);
  }

  constructor(block) {
    this.quantityInput = block.querySelector('.input');

    this.setupQuantityPurchase();
  }

  setupQuantityPurchase() {
    this.initialInputValues = [];
    const input = this.quantityInput;

    const product = input.parentElement.parentElement;
    const addButton = product.querySelector('.add-button');
    const minusButton = product.querySelector('.minus');
    const plusButton = product.querySelector('.plus');

    this.initialInputValues.push(input.value);

    minusButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (input.value > 0) {
        input.value = parseInt(input.value, 10) - 1;
        input.dispatchEvent(new Event('change'));
      }
    });

    plusButton.addEventListener('click', (e) => {
      e.preventDefault();
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change'));
    });

    if (addButton) {
      input.addEventListener('change', () => {
        addButton.dataset.quantity = input.value;

        if (input.value > 1) {
          minusButton.disabled = false;
        } else {
          minusButton.disabled = true;
        }
      });

      addButton.addEventListener('click', (e) => {
        e.preventDefault();

        const { quantity, productId, price } = addButton.dataset;

        Cart.addProduct(productId, parseInt(quantity, 10), parseInt(price, 10));
      });

      this.updateAddButtonLabel(addButton);
    }
  }

  updateAddButtonLabel(addButton) {
    const label = addButton.querySelector('.label');
    const { shortLabel } = label.dataset;
    const { longLabel } = label.dataset;


    if (window.innerWidth < 768 && label.innerText === longLabel.toUpperCase()) {
      label.innerText = shortLabel;
    } else if (window.innerWidth >= 768 && label.innerText === shortLabel.toUpperCase()) {
      label.innerText = longLabel;
    }
    window.addEventListener('resize', debounce(() => {
      if (window.innerWidth < 768 && label.innerText === longLabel.toUpperCase()) {
        label.innerText = shortLabel;
      } else if (window.innerWidth >= 768 && label.innerText === shortLabel.toUpperCase()) {
        label.innerText = longLabel;
      }
    }), 300);
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-product-header', BrixProductHeader.init);
}
